import * as NextSkyTheme from "@NextSkyTheme/global";
import { eventModal } from "@NextSkyTheme/modal";

if (!customElements.get("outfit-item")) {
  customElements.define(
    "outfit-item",
    class OutfitItem extends HTMLElement {
      constructor() {
        super();
        this.isAction = this.querySelector("outfit-action");
      }

      connectedCallback() {
        this.isAction.addEventListener(
          "click",
          this.initPopup.bind(this),
          false,
        );
        this.isAction.addEventListener(
          "keypress",
          function (event) {
            if (event.key === "Enter") {
              this.initPopup.bind(this)(event);
            }
          }.bind(this),
          false,
        );
      }

      initPopup() {
        const template = this.querySelector("template.outfit-popup");
        if (template) {
          const content = document.createElement("div");
          content.appendChild(
            template.content.firstElementChild.cloneNode(true),
          );
          NextSkyTheme.getBody().appendChild(
            content.querySelector("outfit-popup"),
          );
          setTimeout(
            () =>
              eventModal(document.querySelector("outfit-popup"), "open", true),
            100,
          );
        }
        NextSkyTheme.global.rootToFocus = this.isAction;
      }
    },
  );
}

document.addEventListener("DOMContentLoaded", () => {
  const initViewMoreOutfit = () => {
    const viewMoreButtons = document.querySelectorAll(".view-more-outfit-js");
    viewMoreButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const section = button.closest(".section");
        if (section) {
          const hiddenOutfits = section.querySelectorAll(".hidden-outfit");
          hiddenOutfits.forEach((item) => {
            item.classList.remove("hidden-outfit");
          });
          button.parentElement.classList.add("hidden");
        }
      });
    });
  };
  initViewMoreOutfit();

  // Re-init for Shopify Theme Editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      initViewMoreOutfit();
    });
  }
});
